<template>
    <div class="role-member">
        <el-select v-model="role" @click.native="loadRole" multiple placeholder="请选择" style="width: 100%" clearable filterable
            size="mini">
            <el-option v-for="item in options" :key="item.id" :label="item.role_name" :value="item.id">
            </el-option>
        </el-select>
    </div>
</template>

<script>
export default {
    name: 'RoleMember',
    data() {
        return {
            role: [],
            options: []
        }
    },
    methods: {
        loadRole() {
            this.$axios.post('/api/api3_common_get_role',{
                closeLoading: true
            }).then(({data}) => {
                if (data.code === 0) {
                    this.options = data.data
                }
            }).catch()
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/commonReform/RoleMember.vue